import { error, MessageType, success } from '../MessageContext';
import { plural } from '../util/StringUtil';

type SyncedItem = { id: number; name: string };

/**
 * The sync API only returns the entries that synced, so anything missing from the response failed.
 * Name the failed organisations rather than reporting a blanket success.
 */
export function syncResultMessage(selected: SyncedItem[], updatedIds: number[]): MessageType {
  const failed = selected.filter(item => !updatedIds.includes(item.id));
  if (failed.length === 0) {
    return success(`Synced ${plural(selected.length, 'organisation')} with Xero`, { icon: 'sync' });
  }
  const syncedCount = selected.length - failed.length;
  return error(
    `Synced ${syncedCount} of ${plural(selected.length, 'organisation')}. Couldn't sync: ${failed.map(item => item.name).join(', ')}. ` +
      'Please try again, or log out and back in if it keeps failing.',
  );
}
